import React, { useEffect, useState } from 'react';
import {
  InputWrapper,
  Quest,
  QuestContainer,
  Or,
  StyledText,
  CheckboxContainer,
  FullNameContainer,
  For,
  Name,
  EventContainer,
  RehearsalVenueText,
  RehearsalVenueAddress,
  CheckboxContainerForReceiving,
  NoteText,
  CheckboxContainerNote,
} from './Confirmation.styles';
import Input from '../../utils/Input/Input';
import Button from '../../utils/Button/Button';
import { useNavigate } from 'react-router-dom';
import CheckboxInput from '../../utils/CheckboxGuest/CheckboxInput';
import FormContainer from '../../utils/FormContainer/FormContainer';
import {
  selectCreateGuestAnswersPending,
  selectGuestAnswers,
  selectGuestFlow,
  selectInvitationGuestMembers,
  selectRSVPInfo,
  setCurrentGuestIdAndFinished,
  setGuestContactAndRehearsal,
  setGuestQuestionAnswersAndFinish,
} from '../../../store/slice/rsvp/slice';
import { useDispatch, useSelector } from 'react-redux';
import { createGuestAnswers } from '../../../store/slice/rsvp/asyncThunks';
import { dateFormatter } from '../../../utils/utils';
import PhoneNumberInput from '../../utils/PhoneInput/PhoneNumberInput';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { ReactComponent as Checked } from '../../../assets/icons/checked-icon.svg';
import { ReactComponent as Unchecked } from '../../../assets/icons/unchecked-icon.svg';

const Confirmation = ({ rsvpKey }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const rsvp = useSelector(selectRSVPInfo);

  const [email, setEmail] = useState('');

  const [phone, setPhone] = useState({ value: '', formattedValue: '' });

  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const guestFlow = useSelector(selectGuestFlow);
  const { data } = useSelector(selectInvitationGuestMembers);
  const [currentGuest, setCurrentGuest] = useState({});
  const guestAnswers = useSelector(selectGuestAnswers);
  const [noteChecked, setNoteChecked] = useState(false);

  const createGuestAnswersPending = useSelector(selectCreateGuestAnswersPending);

  useEffect(() => {
    if (data.length) {
      const find = data.find(guest => guest.id === guestFlow.currentGuestOnFlowId);
      if (find) {
        setCurrentGuest(find);
      }
    }
  }, [data, guestFlow.currentGuestOnFlowId]);

  const onContinue = () => {
    dispatch(
      setGuestContactAndRehearsal({
        email,
        phoneNumber: phone.value,
        id: data[guestFlow.finished].id,
        attendingRehearsalDinner: selectedAnswer === 1 ? true : false,
      }),
    );

    if (rsvp.questions.length > 0) {
      const query = { key: rsvpKey, step: 'RESTRICTIONS' };
      const queryString = new URLSearchParams(query).toString();
      const url = `/wedding-guest?${queryString}`;
      navigate(url);
    } else {
      const isAnyoneConfirmed = guestAnswers.find(
        guest => guest.confirm === true && guest.finished === false && guest.id !== guestFlow.currentGuestOnFlowId,
      );
      if (guestFlow.finished === data.length - 1 || !isAnyoneConfirmed) {
        let newGuestAnswers = [];
        for (const guest of guestAnswers) {
          let formattedGuest = { ...guest };
          if (guest.id === data[guestFlow.finished].id) {
            formattedGuest.email = email;
            formattedGuest.phoneNumber = phone.value;
            formattedGuest.attendingRehearsalDinner = selectedAnswer === 1 ? true : false;
          }
          newGuestAnswers.push(formattedGuest);
        }

        const setData = {
          id: data[0].guestInvitationId,

          body: {
            guestMembers: newGuestAnswers,
          },
        };
        dispatch(createGuestAnswers(setData))
          .unwrap()
          .then(() => {
            const query = { key: rsvpKey, step: 'SEEYASOON', answer: 'ACCEPTED' };
            const queryString = new URLSearchParams(query).toString();
            const url = `/wedding-guest?${queryString}`;

            navigate(url);
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        dispatch(setGuestQuestionAnswersAndFinish({ id: guestFlow.currentGuestOnFlowId }));

        if (isAnyoneConfirmed) {
          const index = guestAnswers.findIndex(
            guest => guest.confirm === true && guest.finished === false && guest.id !== guestFlow.currentGuestOnFlowId,
          );
          dispatch(
            setCurrentGuestIdAndFinished({
              currentGuestOnFlowId: isAnyoneConfirmed.id,
              finished: index,
            }),
          );

          setEmail('');
          setPhone({ value: '+1', formattedValue: '+1' });
          setSelectedAnswer(null);
          const query = { key: rsvpKey, step: 'CONFIRMATION' };
          const queryString = new URLSearchParams(query).toString();
          const url = `/wedding-guest?${queryString}`;
          navigate(url);
        }
      }
    }
  };

  const question = {
    id: 1,
    quest: 'Will you be attending?',
    answers: [
      { id: 1, answer: 'Yes' },
      { id: 2, answer: 'No' },
    ],
  };

  const handleAnswerClick = answerId => {
    if (selectedAnswer === answerId) {
      setSelectedAnswer(null);
    } else {
      setSelectedAnswer(answerId);
    }
  };
  return (
    <FormContainer message={'Just a few more things..'}>
      <InputWrapper>
        <FullNameContainer>
          <For>For:</For>
          <Name>{data.length ? currentGuest.firstName + ' ' + currentGuest.lastName : 'Name not found'}</Name>
        </FullNameContainer>
        <Quest>
          Please provide the happy couple with your phone number to receive important information on the day of the
          event
        </Quest>
        <PhoneNumberInput phone={phone} setPhone={setPhone} placeholder={'Required'} />
        <Or>Or</Or>
        <Input placeholder={'Enter Email Address'} value={email} onChange={e => setEmail(e.target.value)} />
        <CheckboxContainerForReceiving>
          <CheckboxContainerNote onClick={() => setNoteChecked(!noteChecked)}>
            {noteChecked ? <Checked height={25} width={25} /> : <Unchecked height={25} width={25} />}
          </CheckboxContainerNote>
          <NoteText>
            I agree to receive messages from the couple at the phone number provided above. Reply STOP to opt out.
          </NoteText>
        </CheckboxContainerForReceiving>
      </InputWrapper>
      {currentGuest && currentGuest.rehearsalDinner && (
        <CheckboxContainer>
          <StyledText>You have been invited to the rehearsal dinner!</StyledText>
          <EventContainer>
            <RehearsalVenueText>{rsvp.rehearsalVenueName}</RehearsalVenueText>
            {rsvp.venueAddress && <RehearsalVenueAddress>{rsvp.rehearsalVenueAddress}</RehearsalVenueAddress>}
            {rsvp.venueAddress && <RehearsalVenueText> {dateFormatter(rsvp.dateOfRehearsalDinner)}</RehearsalVenueText>}
          </EventContainer>
          <QuestContainer>
            <Quest>{question.quest}</Quest>
            {question.answers.map(a => (
              <CheckboxInput
                key={a.id}
                onClick={() => handleAnswerClick(a.id)}
                checked={selectedAnswer === a.id}
                label={a.answer}
              />
            ))}
          </QuestContainer>
        </CheckboxContainer>
      )}
      {/* <InputWrapper>
        <Quest>What song will get you on the dance floor?</Quest>
        <Input placeholder={'Enter Tunes'} value={tunes} onChange={e => setTunes(e.target.value)} />
      </InputWrapper> */}

      <Button
        width
        title={'Continue'}
        disabled={
          !isValidPhoneNumber(phone.value) ||
          (currentGuest.rehearsalDinner && !selectedAnswer) ||
          !noteChecked ||
          createGuestAnswersPending
        }
        onClick={onContinue}
        loading={createGuestAnswersPending}
      />
    </FormContainer>
  );
};

export default Confirmation;
